// Removes leading spaces
export const removeLeadingSpaces = (value) => {
    return value.replace(/^\s+/, '');
};

// Ensures the value contains only alphabets and spaces
export const acceptOnlyAlphabets = (value) => {
    // Allow alphabets and spaces
    return value.replace(/[^a-zA-Z\s]/g, '');
};




// Ensures the value contains only numbers
export const acceptOnlyNumbers = (value) => {
    return value.replace(/[^0-9]/g, ''); // Removes non-numeric characters
};
